module.exports = __webpack_public_path__ + "static/img/news1.0fdfea8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news5/news1.jpg
// module id = 1Uqe
// module chunks = 1